import {
  getIngredients,
  getObjectCompanies
} from "../../api/additional"


export default {
  FETCH_INGREDIENTS({
                      commit
                    }, params) {
    return new Promise((resolve, reject) => {
      getIngredients(params).then(res => {
        commit('SET_INGREDIENTS', res.data)
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },

  FETCH_OBJECT_COMPANIES({
                           commit
                         }, params) {
    return new Promise((resolve, reject) => {
      getObjectCompanies(params).then(res => {
        commit('SET_OBJECT_COMPANIES', res.data)
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
